import { createAPI } from '@common'

export default {
// 读当前登录用户有权限的门户信息
  getPortals: config => createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfs0qpsubmt', 'get', config),
  getTempToken: config => createAPI('customEncryptApiName-1/w20uijseqbsuz0mphjo0ufnqUplfo', 'get', config),
  getAutologinChecksum: config => createAPI('customEncryptApiName-1/0f60bvupmphjo0difdltvn', 'get', config),
  postMainSitesChange: config => createAPI('customEncryptApiName-1/0w20nbjo0tjuft0dibohf', 'post', config),
  // 刷新缓存
  postE5AdminCachesAll: config => createAPI('customEncryptApiName-1/0f60benjo0dbdift0bmm', 'post', config),
  // 获取验证码
  postE5LoginCaptcha: config => createAPI('customEncryptApiName-1/0f60mphjo0dbqudib', 'get', config),
  // 获取logo和标题
  getLogoConfig: config => createAPI('customEncryptApiName-1/0w20nbjo0dpogjh', 'get', config, {isHideErrorMessage: true}),
  // 登陆验证-云端稿库
  postE5LoginValidation: config => createAPI('customEncryptApiName-1/0f60mphjo0wbmjebujpo', 'post', config),
  // 登陆验证-采编发
  postMainLoginValidation: config => createAPI('customEncryptApiName-1/0w20nbjo0mphjo0wbmjebujpo', 'post', config),
  // 获得公钥
  getPublicKey: config => createAPI('customEncryptApiName-1/0w20nbjo0qvclfz', 'get', config),
  // 指令详情
  getCommandReceiverDetail: config => createAPI('customEncryptApiName-1/0w20ss0dpnnboe0sfdfjwfs0efubjm', 'get', config),
  // 上报
  postCommandreceiverReport: config => createAPI('customEncryptApiName-1/0w20ss0dpnnboe0sfdfjwfs0sfqpsu', 'post', config),
  // 获取未读指令条数
  getRrCommandReceiverCountNew: config => createAPI('customEncryptApiName-1/0w20ss0dpnnboe0sfdfjwfs0dpvouOfx', 'get', config),
  postNoticeClose: config => createAPI('customEncryptApiName-1/0w20ss0opujdf0dmptf', 'post', config, {neverLoading: true}),
  postNoticeCloseAll: config => createAPI('customEncryptApiName-1/0w20ss0opujdf0dmptf0bmm', 'post', config, {neverLoading: true}),
  // 修改密码
  postLoginPassword: config => createAPI('customEncryptApiName-1/0w20mphjo0qbttxpse', 'post', config),
  // 修改头像
  postMainUserIcon: config => createAPI('customEncryptApiName-1/0w20nbjo0vtfs0jdpo', 'post', config),
  // 获取通知条数
  getRrNoticeCount: config => createAPI('customEncryptApiName-1/0w20ss0opujdf0dpvou', 'get', config),
  // 获取我的消息条数
  getRrNoticePCount: config => createAPI('customEncryptApiName-1/0w20ss0opujdf0q0dpvou', 'get', config),
  // 获取二维码
  getMainUserQRCode: config => createAPI('customEncryptApiName-1/0w20nbjo0vtfs0rsdpef', 'get', config),
  // 获取公告
  getNotesLatest: config => createAPI('customEncryptApiName-1/0f60opuft0mbuftu', 'get', config),
  // 读系统版本号
  getDeplayVersion: config => createAPI('customEncryptApiName-1/0w20efqmpz0wfstjpo', 'get', config, { neverLoading: true }),
  // 个人消息未读数
  getRRNoticeRedhot0: config => createAPI('customEncryptApiName-1/0w20ss0opujdf0sfeipu1', 'get', config),
  // 获取手机号验证码
  postMainUserBindCode: config => createAPI('customEncryptApiName-1/0w20nbjo0vtfs0cjoe0dpef', 'POST', config),
  // 提交短信验证码
  postMainUserBind: config => createAPI('customEncryptApiName-1/0w20nbjo0vtfs0cjoe', 'POST', config),
  // 获取base64Image
  getE5Images: (config) => createAPI('customEncryptApiName-1/0f60jnbhft', 'get', config)
}
